import React from 'react';
import classes from './OrderSummary.css';
import SummaryButtons from './SummaryButtons/SummaryButtons';

const orderSummary = (props) => {

  let summaryButtons = null;
  let orderSummaryClasses = [classes.OrderSummary];

  if (props.cancel) {
    summaryButtons = <SummaryButtons continue={props.continue} isAuth={props.isAuth} cancel={props.cancel} />
  } else {
    orderSummaryClasses.push(classes.LessPadding);
  }

  const ingredientSummary = Object.keys(props.ingredients).map(ingredient => {
    if (props.ingredients[ingredient] !== 0) {
      return <div className={classes.SummaryItem} key={ingredient}>
        <p className={classes.SummaryIngredient}>{ingredient}</p>
        <div className={classes.DividingLine}></div>

        <p className={classes.Calculations}>{`$${props.prices[ingredient].toFixed(2)}`} x {props.ingredients[ingredient]} = {`$${(props.ingredients[ingredient] * props.prices[ingredient]).toFixed(2)}`}</p>
      </div>
    } else {
      return null;
    }
  })
  return <div className={orderSummaryClasses.join(' ')}>
    <div className={classes.Header}>
      <h2 className={classes.SummaryHeader}>{props.title ? props.title : 'Order Summary'}</h2>
    </div>

    <div className={classes.SummaryItems}>
      <div className={classes.SummaryItem}>
        <p>base price</p> <div className={classes.DividingLine}></div><p className={classes.Calculations}>$4.00</p>
      </div>

      {ingredientSummary}

    </div>
    <br />
    <p className={classes.Total}><strong>Total: {`$${props.total.toFixed(2)}`}</strong></p>
    <br />
    {summaryButtons}
  </div>
}

export default orderSummary;


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/OrderSummary.jsx